import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AdvanceSearchUserModal } from 'src/modules/features/ngx-filter/modals';
import { CreateAlertModal } from 'src/modules/features/setting/modals/app-security-modals/create-alert-modal/create-alert-modal.component';
import { SecurityConfirmationModal } from 'src/modules/features/setting/modals/app-security-modals/security-confirmation-modal/security-confirmation-modal.component';
import { ApplicationSecurityService } from 'src/modules/features/setting/components/application-security/services/application-security.service';

@Component({
  selector: 'app-event-log',
  templateUrl: './event-log.component.html',
  styleUrls: ['./event-log.component.scss'],
})
export class EventLogComponent implements OnInit {
  filter: AppFilter = new AppFilter({ sidx: 'dateCreated' });
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  logs: Array<any> = [];
  error: any;
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'description',
        op: 'cn',
        data: '',
      },
    ],
  };

  headers: any[] = [
    {
      field: 'eventDescription',
      label: 'description',
      type: 'text',
      op: 'cn',
      data: '',
    },

    {
      field: 'eventType',
      label: 'Event Type',
      type: 'select',
      op: 'eq',
      choices: [
        {
          optionId: 'IP_ADDRESS',
          optionName: 'IP Address',
        },
        {
          optionId: 'GEO_FENCE',
          optionName: 'Geo Fence',
        },
        {
          optionId: 'RATE_LIMIT',
          optionName: 'Rate Limit',
        },
        {
          optionId: 'LOGIN_ATTEMPT',
          optionName: 'Login Attempt',
        },
        {
          optionId: 'MALICIOUS_REQUEST',
          optionName: 'Malicious Request',
        },
        {
          optionId: 'FILE_UPLOAD',
          optionName: 'File Upload',
        },
      ],
      data: '',
    },
  ];
  fieldx: any[] = [];
  organizationId: string;
  success: any;
  constructor(
    private appSecuritySvc: ApplicationSecurityService,
    private modalService: SuiModalService,
    private router: Router
  ) {
    this.logs = [];
  }

  ngOnInit(): void {
    this.getPage(1);
  }

  getPage(page: number) {
    this.filter.page = page;
    this.pending = true;
    this.appSecuritySvc
      .getEventLogs({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.currentPage = page;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.logs = res['rows'];
          this.logs = res['rows'].map((log) => ({
            ...log,
            status: this.getLogStatus(log),
          }));
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  viewLogDetail(log) {}

  openBlacklistIPAddressModal(log) {
    let ipAddress = log.metaData ? JSON.parse(log.metaData).ipAddress : '';
    this.modalService
      .open(
        new SecurityConfirmationModal(
          'Whitelist IP Address',
          `Are you sure you want to whitelist this IP address? ${ipAddress}`,
          'Yes'
        )
      )
      .onApprove(() => {
        this.whitelistIpAddress(ipAddress);
      })
      .onDeny(() => {});
  }

  onCreateLogAlertModal(log) {
    this.modalService
      .open(
        new CreateAlertModal('Create Alert', {
          pageType: 'Event Log',
          log: log,
        })
      )
      .onApprove(() => {
        this.createLogAlert(log);
      })
      .onDeny(() => {});
  }

  whitelistIpAddress(ipAddress): void {
    this.pending = true;
    this.appSecuritySvc
      .whitelistIpAddress({
        blacklistedIpId: ipAddress,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.success =
            res && res.message ? res.message : 'whitelist Successful';
          setTimeout(() => {
            this.success = '';
            this.getPage(this.currentPage);
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  createLogAlert(log) {}

  adSearchFilter = {
    groupOp: 'OR',
    rules: [],
  };
  searchAd(event) {
    event = Object.assign({}, event);
    // event.rules = event.rules.filter(
    //   (rule) =>
    //     rule.field !== 'organizationId.organizationTypeId.organizationTypeId'
    // );

    this.filter.filters = JSON.stringify(event);
    this.filter.page = 1;
    this.getPage(this.filter.page);
  }

  searchModal() {
    this.modalService
      .open(
        new AdvanceSearchUserModal(
          'Advance Search',
          this.headers,
          this.fieldx,
          ModalSize.Tiny
        )
      )
      .onApprove((payload: any) => {
        this.fieldx = payload.filter;
        this.searchAd(payload.search);
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }

  searchRecords(search) {
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      this.getPage(this.filter.page);
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'eventDescription',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      // searchFilter.rules[1].data = search;
      // searchFilter.rules[2].data = search;
      // searchFilter.rules[3].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
      this.getPage(this.currentPage);
    }
  }

  cancelAd() {
    this.searchFilter.rules[0].data = '';
    this.searchFilter.rules.length = 0;
    this.filter.filters = JSON.stringify(this.searchFilter);

    this.getPage(this.currentPage);
  }

  getLogStatus(log): string {
    if (!log) return;

    return JSON.parse(log.metaData).status;
  }

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(this.currentPage);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }
}
